export default __webpack_public_path__ + "static/media/swiperJS.079767bc.PNG";